import { useProvider } from "./context";
import { RiDeleteBinLine } from "react-icons/ri";
export default function NoteComponent({
  data = { id: null, desc: "", date: "" }
}) {
  const { dispatch } = useProvider();
  const { id, desc, date, bgColor } = data;
  return (
    <div key={id} style={{ background: bgColor }} className="note">
      <textarea
        className="textbox"
        defaultValue={desc}
        style={{ background: bgColor, resize: "none" }}
        onKeyDown={(e) => {
          if (e.key === "Enter") {
            dispatch({ type: "UPDATE", payload: { id, desc: e.target.value } });
          }
        }}
      />
      <div className="action">
        <div className="date">{date.split(" ").slice(1, 4).join(" ")}</div>
        <button
          onClick={() => {
            dispatch({ type: "DELETE", payload: { id } });
          }}
          className="delete"
        >
          <RiDeleteBinLine />
        </button>
      </div>
    </div>
  );
}
